import { Spinner } from '../../../../assets/icon/svg'
import CloseButtonModal from '../../../ui/close-button-modal';

interface Props {
    handleCloseModal: () => void;
}

export default function LoadingProfileModal({ handleCloseModal }: Props) {
    return (
        <div className='fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-4'>
            <div className='relative bg-white rounded shadow w-full sm:w-96 md:w-[80%] lg:w-[65%] max-h-[90vh] min-h-[400px] overflow-y-hidden p-6'>
                <div className={`space-y-4`}>
                    <div className="flex justify-between items-center py-1">
                        <div className="items-start">
                            <p className="text-base items-start font-semibold leading-tight text-slate-900">
                                {''}
                            </p>
                        </div>
                        <div className="flex justify-end items-center">
                            <CloseButtonModal handleClose={handleCloseModal}/>
                        </div>
                    </div>
                    <hr className="h-px bg-gray-200 border-0" />
                    <div className='h-[250px] flex items-center justify-center'>
                        <div className="flex justify-center items-center h-full w-full">
                            <Spinner color={'#186cb2'} size={30} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
